/**
 * IPD Product Groups reference data
 * Canonical list of product groups used for filtering and display
 */

export type ProductGroupKey =
  | 'fresh-produce'
  | 'natural-ingredients'
  | 'fish-seafood'
  | 'cut-flowers'
  | 'tourism'
  | 'digital-services';

export interface ProductGroup {
  key: ProductGroupKey;
  label: string;
  description?: string;
}

export const IPD_PRODUCT_GROUPS: ProductGroup[] = [
  { key: 'fresh-produce', label: 'Fresh Produce', description: 'Fruit, vegetables, herbs, etc.' },
  { key: 'natural-ingredients', label: 'Natural Ingredients', description: 'Food, pharma, cosmetics ingredients' },
  { key: 'fish-seafood', label: 'Fish & Seafood', description: 'Including aquaculture' },
  { key: 'cut-flowers', label: 'Cut Flowers', description: 'Roses and summer flowers' },
  { key: 'tourism', label: 'Tourism', description: 'Sustainable tourism' },
  { key: 'digital-services', label: 'Digital Services', description: 'Software, BPO, digital solutions' },
];

const PRODUCT_GROUP_KEYS = new Set<string>(IPD_PRODUCT_GROUPS.map((g) => g.key));

/**
 * Get the display label for a product group key
 */
export function getProductGroupLabel(key: ProductGroupKey): string {
  const group = IPD_PRODUCT_GROUPS.find((g) => g.key === key);
  return group?.label ?? key;
}

/**
 * Type guard to check if a string is a valid ProductGroupKey
 */
export function isValidProductGroupKey(v: string): v is ProductGroupKey {
  return PRODUCT_GROUP_KEYS.has(v);
}
